import {CtModelRouteData} from "@ctsolution/ct-framework";

export const WorkOrderEventLogRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("WorkOrderEventLog");